export default __webpack_public_path__ + "static/favicon-b01902d22b6bcae787062700e2accfef.ico";